import React, { useContext, useState } from "react";
import AppContext from "../contexts/AppContext";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Typography from "@material-ui/core/Typography";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import IconButton from "@material-ui/core/IconButton";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import EditIcon from "@material-ui/icons/Edit";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Grid, Menu, MenuItem } from "@material-ui/core";
import EditRedmineForm from "./organisms/edit_redmine_form";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import componentStyles from "../assets/styles/components/config_list";
import { useTranslation } from "react-i18next";

import { setEditConfig, resetEditConfig } from "../actions";
import { useConfig } from "../hooks/useConfig";
import { useIssueStatuses } from "../hooks/useIssueStatuses";

const useStyles = makeStyles(componentStyles);

const ConfigList = (props) => {
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(null);
  const { state, dispatch } = useContext(AppContext);
  const { deleteConfig } = useConfig();
  const { getIssueStatuses, issueStatuses, loading } = useIssueStatuses();

  const { handleClickSetConfig } = props;
  const classes = useStyles();
  const theme = useTheme();
  const { t } = useTranslation();

  const handleClickDelete = () => setOpenDeleteDialog(true);
  const handleClickEdit = () => setOpenEditDialog(true);
  const handleClickMore = (e, config) => {
    const { id, name, redmineurl, taskListStatus, apikey } = config;
    setEditConfig(dispatch, { id, name, redmineurl, taskListStatus });
    setMoreMenuAnchorEl(e.currentTarget);
    getIssueStatuses({ redmineurl, apikey });
  };
  const handleCloseMore = () => {
    setMoreMenuAnchorEl(null);
    resetEditConfig(dispatch);
  };
  const handleClose = () => {
    setOpenDeleteDialog(false);
  };
  const handleExited = () => {
    handleCloseMore();
  };
  const handleClickDeleteConfigButton = async () => {
    await deleteConfig(state.current, state.editConfig.id);
    handleClose();
  };

  return (
    <>
      <List className={classes.listRoot}>
        {state.siteConfigs
          ? state.siteConfigs.map((config, index) => {
              return (
                <ListItem
                  alignItems="flex-start"
                  key={index}
                  button
                  onClick={(e) => handleClickSetConfig(config)}
                  className={classes.listItemRoot}
                >
                  <ListItemIcon>
                    {
                      <FiberManualRecordIcon
                        style={
                          config.id === state.current.id
                            ? { color: theme.palette.success.snackbar }
                            : { color: theme.palette.gray[300] }
                        }
                      />
                    }
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography variant="h3">{config.name}</Typography>
                    }
                    secondary={<Typography>{config.redmineurl}</Typography>}
                  />
                  <ListItemSecondaryAction>
                    <IconButton
                      edge="end"
                      aria-controls="more-menu"
                      aria-haspopup="true"
                      onClick={(e) => handleClickMore(e, config)}
                    >
                      <MoreVertIcon />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
              );
            })
          : ""}
      </List>

      <Menu
        id="configlist-menu"
        anchorEl={moreMenuAnchorEl}
        keepMounted
        open={Boolean(moreMenuAnchorEl)}
        onClose={handleCloseMore}
      >
        <MenuItem onClick={handleClickEdit}>
          <Grid container>
            <Grid item>
              <EditIcon />
            </Grid>
            <Grid>
              <Typography>{t("button_edit")}</Typography>
            </Grid>
          </Grid>
        </MenuItem>
        <MenuItem onClick={handleClickDelete}>
          <Grid container>
            <Grid item>
              <DeleteForeverIcon />
            </Grid>
            <Grid>
              <Typography>{t("button_delete")}</Typography>
            </Grid>
          </Grid>
        </MenuItem>
      </Menu>

      <Dialog
        open={openDeleteDialog}
        onClose={handleClose}
        onExited={handleExited}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <Typography variant="h3">Redmine登録情報の削除</Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`${state.editConfig.name} `}
            をリストから削除しますか？この操作は取り消せません。
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            {t("button_cancel")}
          </Button>
          <Button
            onClick={(e) => handleClickDeleteConfigButton()}
            classes={{ root: classes.buttonDelete }}
          >
            {t("button_delete")}
          </Button>
        </DialogActions>
      </Dialog>

      <EditRedmineForm
        openEditDialog={openEditDialog}
        setOpenEditDialog={setOpenEditDialog}
        handleCloseMore={handleCloseMore}
        issueStatuses={issueStatuses}
        loadingIssueStatuses={loading}
      />
    </>
  );
};

export default ConfigList;
